export const NotFound = () => {
    return <>The provided url does not exist.</>;
};
